import React from 'react';
import { BarChart2Icon } from 'lucide-react';
export const ReportsModule = () => {
  return <div className="space-y-6" data-id="element-3880">
      <h1 className="text-2xl font-bold text-gray-800" data-id="element-3881">Reports</h1>
      <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-3882">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3883">
          <BarChart2Icon className="h-8 w-8 text-blue-600" data-id="element-3884" />
        </div>
        <h2 className="text-xl font-medium text-gray-800 mb-2" data-id="element-3885">
          Reports Module
        </h2>
        <p className="text-gray-600 mb-6 max-w-md mx-auto" data-id="element-3886">
          This module will display sales performance dashboards, booking
          statistics, commission tracking, and downloadable reports.
        </p>
      </div>
    </div>;
};